// Mirrors the createURLParameter() switch in components/Settings/TeamContent/index.jsx
export const lobbyingMaterialUrlParameter = (type: string): string => {
  switch (type) {
    case 'PolicyAsk':
      return 'policy-asks';
    case 'BriefingMaterial':
      return 'briefing-material';
    case 'NewsRelease':
      return 'news-release';
    default:
      return type.toLowerCase();
  }
};

export const lobbyingMaterialEditPath = (type: string, id: number | string): string =>
  `/brief-policymakers/${lobbyingMaterialUrlParameter(type)}/edit/${id}/2`;
